import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import api from '../config/api';

export default function MyProfile() {
  const [form, setForm] = useState({
    username: "",
    password: "",
    role: "",
    is_active: true,
  });
  const [isEditing, setIsEditing] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const token = localStorage.getItem("token");
  const userId = JSON.parse(atob(token.split(".")[1])).user_id;

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await fetch(api(`/users/${userId}`), {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await response.json();
        setForm({
          username: data.username || "",
          password: "",
          role: data.role || "",
          is_active: data.is_active,
        });
      } catch (err) {
        console.error("Failed to fetch user profile", err);
      }
    };

    fetchProfile();
  }, [userId, token]);

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleCancel = () => {
    window.location.reload(); // reset semua perubahan
  };

  const handleSave = async () => {
    try {
      const response = await fetch(api(`/users/${userId}`), {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(form),
      });

      if (!response.ok) {
        const err = await response.json();
        setErrorMessage(err.error || "Failed to update profile");
        return;
      }

      alert("Profile updated successfully");
      setIsEditing(false);
    } catch (err) {
      console.error("Failed to update profile", err);
      setErrorMessage("Something went wrong.");
    }
  };

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Sidebar />
        <div className="layout-page">
          <Navbar />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <h3 className="mb-4">My Profile</h3>
              <div className="card p-4">
                {errorMessage && (
                  <div className="alert alert-danger">{errorMessage}</div>
                )}
                <form>
                  <div className="mb-3">
                    <label className="form-label">Username</label>
                    <input
                      type="text"
                      className="form-control"
                      name="username"
                      value={form.username}
                      onChange={handleChange}
                      disabled={!isEditing}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Password</label>
                    <input
                      type="password"
                      className="form-control"
                      name="password"
                      value={form.password}
                      onChange={handleChange}
                      disabled={!isEditing}
                      placeholder="Leave blank to keep unchanged"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Role</label>
                    <input
                      type="text"
                      className="form-control"
                      name="role"
                      value={form.role}
                      disabled
                    />
                  </div>
                  <div className="form-check mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="is_active"
                      checked={form.is_active}
                      onChange={handleChange}
                      disabled={!isEditing}
                      id="isActiveCheck"
                    />
                    <label className="form-check-label" htmlFor="isActiveCheck">
                      Active
                    </label>
                  </div>
                </form>

                <div className="mt-3 d-flex gap-2">
                  {!isEditing ? (
                    <button className="btn btn-primary" onClick={() => setIsEditing(true)}>
                      Edit
                    </button>
                  ) : (
                    <>
                      <button className="btn btn-success" onClick={handleSave}>
                        Save
                      </button>
                      <button className="btn btn-secondary" onClick={handleCancel}>
                        Cancel
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
